// extracted by mini-css-extract-plugin
export default {"list":"positions_list-module___list___ae67917b"};